/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';

export const LogFileDescriptor = yup.object({
   filename: yup.string(),
   lastModified: yup.date(),
});
export type ILogFileDescriptor = yup.InferType<typeof LogFileDescriptor>;

export const LogFileDescriptorWithId = LogFileDescriptor.shape({
   id: yup.idString(),
}).from('filename', 'id', true);
export type ILogFileDescriptorWithId = yup.InferType<typeof LogFileDescriptorWithId>;

export const LogFileDescriptorsWithId = yup.array().of(LogFileDescriptorWithId);
